export enum AssignmentSaveOperation {
    SAVE = "SAVE",
    UPDATE = "UPDATE",
    DELETE = "DELETE"
}